import http from '../http-common';

class UserGroupDataService {
  getAll() {
    return http.get("/user-group");
  }

  getAllType(id) {
    return http.get(`/user-group/type/${id}`);
  }

  get(id) {
    return http.get(`/user-group/edit/${id}`);
  }

  create(data) {
    return http.post("/user-group/add", data);
  }

  update(id, data) {
    return http.put(`/user-group/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/device-group/delete/${id}`);
  }
}

export default new UserGroupDataService();
